module.exports = __webpack_public_path__ + "img/icon_system_terminal_controller.5ec49795.svg";